import { render, staticRenderFns } from "./ContentRouter.vue?vue&type=template&id=5b660286"
import script from "./ContentRouter.vue?vue&type=script&lang=js"
export * from "./ContentRouter.vue?vue&type=script&lang=js"
import style0 from "./ContentRouter.vue?vue&type=style&index=0&id=5b660286&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports